import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import TopMenu from "./TopMenu";
import Notifications from "src/components/notifications/Notifications";

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();

  const [notificationOpen, setNotificationOpen] = useState(false);

  const [hasNotifications, setHasNotifications] = useState(false);

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const logoutConfirmed = useRef(false);
  const historyLocked = useRef(false);

  const confirmLogout = () => {
    logoutConfirmed.current = true;

    localStorage.clear();
    sessionStorage.clear();

    setShowLogoutModal(false);

    navigate("/portal", {
      replace: true,
    });
  };

  useEffect(() => {
    // Add one history entry so the first Back stays inside the app.
    window.history.pushState(
      { secure: true },
      "",
      window.location.href
    );

    const handlePopState = () => {
      if (logoutConfirmed.current) return;

      if (historyLocked.current) return;

      historyLocked.current = true;

      setShowLogoutModal(true);

      // Keep the user on the secure page.
      window.history.pushState(
        { secure: true },
        "",
        window.location.href
      );
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#f5f5f5] relative">

      {/* ================= HEADER ================= */}

      <Header
  onOpenNotifications={() =>
    setNotificationOpen(true)
  }
  hasNotifications={hasNotifications}
/>

      {/* ================= TOP MENU ================= */}

      <TopMenu
        onLogoutClick={() =>
          setShowLogoutModal(true)
        }
      />

      {/* ================= PAGE CONTENT ================= */}

      <main>{children}</main>

      {/* ================= OVERLAY ================= */}

      {notificationOpen && (
        <div
          className="
            fixed
            inset-0
            bg-black/20
            backdrop-blur-[1px]
            z-[9998]
            transition-opacity
            duration-200
          "
          onClick={() =>
            setNotificationOpen(false)
          }
        />
      )}

      {/* ================= NOTIFICATION DRAWER ================= */}

      <Notifications
  open={notificationOpen}
  onClose={() =>
    setNotificationOpen(false)
  }
  onNotificationStatusChange={setHasNotifications}
/>

           {/* ================= LOGOUT MODAL ================= */}

      {showLogoutModal && (
        <div
          className="
            fixed
            inset-0
            z-[99999]
            flex
            items-center
            justify-center
            bg-black/35
            backdrop-blur-md
          "
        >
          <div
            className="
              w-[400px]
              overflow-hidden
              rounded-[20px]
              bg-white
              shadow-[0_35px_80px_rgba(0,0,0,0.22)]
            "
          >
            {/* TOP ACCENT */}

            <div className="h-[4px] bg-gradient-to-r from-[#d40000] via-[#e53935] to-[#d40000]" />

            {/* CONTENT */}

            <div className="px-6 pt-5 pb-3">

              <h2
                className="
                  text-center
                  text-[24px]
                  font-light
                  text-[#1b1b1b]
                "
                style={{
                  fontFamily:
                    "'UBS Frutiger', Arial, sans-serif",
                }}
              >
                Logout
              </h2>

              <p
                className="
                  mt-3
                  text-center
                  text-[14px]
                  leading-7
                  text-[#666]
                "
                style={{
                  fontFamily:
                    "'UBS Frutiger', Arial, sans-serif",
                }}
              >
                Are you sure you want to logout from your
                UBS E-Banking session?
              </p>

            </div>

            {/* FOOTER */}

            <div className="px-8 pb-8 flex justify-center gap-4">

              <button
                onClick={() => {
                  historyLocked.current = false;
                  setShowLogoutModal(false);
                }}
                className="
                  h-[36px]
                  min-w-[105px]
                  rounded-full
                  border
                  border-[#d5d5d5]
                  bg-white
                  text-[#444]
                  text-[14px]
                  font-semibold
                  hover:bg-[#f7f7f7]
                  transition-all
                  duration-200
                "
              >
                Cancel
              </button>

              <button
                onClick={confirmLogout}
                className="
                  h-[36px]
                  min-w-[105px]
                  rounded-full
                  bg-[#d40000]
                  text-white
                  text-[14px]
                  font-semibold
                  hover:bg-[#bc0000]
                  shadow-[0_12px_30px_rgba(212,0,0,0.28)]
                  transition-all
                  duration-200
                  hover:-translate-y-[1px]
                "
              >
                Logout
              </button>

            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default DashboardLayout;